export const STORE_KEY = 'wc/store/validation';
